import { render, staticRenderFns } from "./GuncellemelerDialog.vue?vue&type=template&id=7b726c6b&scoped=true"
import script from "./GuncellemelerDialog.vue?vue&type=script&lang=ts"
export * from "./GuncellemelerDialog.vue?vue&type=script&lang=ts"
import style0 from "./GuncellemelerDialog.vue?vue&type=style&index=0&id=7b726c6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b726c6b",
  null
  
)

export default component.exports